import React from 'react';
import { connect } from 'react-redux';
import MultiBarChart from '../Charts/MultiBarChart';
import LineChart from '../Charts/LineChart';
import AreaChart from '../Charts/AreaChart';
import DoughnutChart from '../Charts/DoughnutChart';
import FunnelChart from '../Charts/FunnelChart';
import GaugeChart from '../Charts/GaugeChart';
import HeatMap from '../Charts/HeatMap';
import ScatterChart from '../Charts/ScatterChart';
import StackedBar from '../Charts/StackedBar';
import CrossTabChart from '../Charts/CrossTab/CrossTabChart';
import HorizontalBar from '../Charts/HorizontalBar';
import Horizontalstacked from '../Charts/Horizontalstacked';
import RoseChart from '../Charts/RoseChart';
import FilledMap from '../Charts/GeoChart/FilledMap';
import BubbleMap from '../Charts/GeoChart/BubbleMap';
import TextEditor from '../Charts/TextEditor/TextEditor';
import CalendarChart from '../Charts/CalendarChart';
import BoxPlotChart from '../Charts/BoxPlotChart';
import TreeMap from '../Charts/TreeMap';
import Sankey from '../Charts/Sankey';
import StackedAreaChart from '../Charts/StackedAreaChart';
import PieChart from '../Charts/PieChart';
import SimpleCard from '../Charts/SimpleCard';
import TableChart from '../Charts/TableChart/TableChart';
import WaterfallChart from '../Charts/WaterfallChart';
import WordCloudChart from '../Charts/WordCloudChart';

const DashGraph = React.memo(
  ({
    // props
    propKey,
    tabId,
    gridSize,
    colorScheme,
    softUI,
    setMapJSON,
    setLoading,
    fontFamily,
    overrideDimensions,

    // state
    tileState,
    chartControls,
    chartProp,
    tabState,
  }: any) => {
    // compute the dimensions of each graph to be displayed in dashboard and render the appropriate graph here
    const renderGraph = () => {
      const rawHeight = overrideDimensions
        ? overrideDimensions.height
        : Number(tabState.tabs[tabId].dashTilesDetails[propKey].height) * gridSize.y;

      const rawWidth = overrideDimensions
        ? overrideDimensions.width
        : Number(tabState.tabs[tabId].dashTilesDetails[propKey].width) * gridSize.x;

      const chartType = chartProp.properties[propKey].chartType;

      const dimensions = {
        height:
          chartType === 'simplecard' || chartType === 'wordCloud' ? rawHeight - 4 : rawHeight - 32,
        width:
          chartType === 'simplecard' || chartType === 'wordCloud'
            ? rawWidth - 4
            : (rawWidth * 24) / 25 - 4,
      };

      switch (chartProp?.properties[propKey]?.chartType) {
        case 'multibar':
          return (
            <div className="{tileStyleSoft}">
              <MultiBarChart
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'waterfall':
          return (
            <div className="{tileStyleSoft}">
              <WaterfallChart
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'horizontalBar':
          return (
            <div className="{tileStyleSoft}">
              <HorizontalBar
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'horizontalStacked':
          return (
            <div className="{tileStyleSoft}">
              <Horizontalstacked
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'crossTab':
          return (
            <div className="{tileStyleSoft}">
              <CrossTabChart
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'stackedBar':
          return (
            <div className="{tileStyleSoft}">
              <StackedBar
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'line':
          return (
            <div className="{tileStyleSoft}">
              <LineChart
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'area':
          return (
            <div className="{tileStyleSoft}">
              <AreaChart
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'pie':
          return (
            <div className="{tileStyleSoft}">
              <PieChart
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'donut':
          return (
            <div className="{tileStyleSoft}">
              <DoughnutChart
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'rose':
          return (
            <div className="{tileStyleSoft}">
              <RoseChart
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'funnel':
          return (
            <div className="{tileStyleSoft}">
              <FunnelChart
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'gauge':
          return (
            <div className="{tileStyleSoft}">
              <GaugeChart
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'heatmap':
          return (
            <div className="{tileStyleSoft}">
              <HeatMap
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'scatterPlot':
          return (
            <div className="{tileStyleSoft}">
              <ScatterChart
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );
        case 'stackedArea':
          return (
            <div className="{tileStyleSoft}">
              <StackedAreaChart
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'filledMap':
          return (
            <div className="{tileStyleSoft}">
              <FilledMap
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                setMapJSON={setMapJSON}
                setLoading={setLoading}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'bubbleMap':
          return (
            <div className="{tileStyleSoft}">
              <BubbleMap
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                setMapJSON={setMapJSON}
                setLoading={setLoading}
                fontFamily={fontFamily}
              />
            </div>
          );

        case 'calendar':
          return (
            <div className="{tileStyleSoft}">
              <CalendarChart
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );
        case 'boxPlot':
          return (
            <div className="{tileStyleSoft}">
              <BoxPlotChart
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );
        case 'treeMap':
          return (
            <div className="{tileStyleSoft}">
              <TreeMap
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
              />
            </div>
          );
        case 'sankey':
          return (
            <div className="{tileStyleSoft}">
              <Sankey
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );
        case 'richText':
          return (
            <div className="{tileStyleSoft}" style={{ height: '100%', width: '100%' }}>
              <TextEditor
                propKey={propKey}
                graphDimension={dimensions}
                colorScheme={colorScheme}

                // chartArea="dashboard"
              />
            </div>
          );
        case 'simplecard':
          return (
            <div className="{tileStyleSoft}">
              <SimpleCard
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );
        case 'table':
          return (
            <div className="{tileStyleSoft}">
              <TableChart
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              ></TableChart>
            </div>
          );
        case 'wordCloud':
          return (
            <div className="{tileStyleSoft}">
              <WordCloudChart
                propKey={propKey}
                graphDimension={dimensions}
                chartArea="dashboard"
                colorScheme={colorScheme}
                softUI={softUI}
                fontFamily={fontFamily}
              />
            </div>
          );
      }
    };
    return <React.Fragment>{renderGraph()}</React.Fragment>;
  },
);

const mapStateToProps = (state: any) => {
  return {
    tileState: state.tileState,
    tabState: state.tabState,
    chartControls: state.chartControls,
    chartProp: state.chartProperties,
  };
};

export default connect(mapStateToProps, null)(DashGraph);
